import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CustomSelectStyle from "./style";
import { Select } from "@mui/material";

export default function CustomSelect({
  label,
  name,
  value,
  items,
  id,
  labelId,
  handleChange,
  disabled,
}) {
  return (
    <Box sx={{ minWidth: 120, mb: 4 }}>
      <CustomSelectStyle fullWidth>
        <InputLabel id={labelId} sx={{ fontSize: "18px" }}>
          {label}
        </InputLabel>
        <Select
          native={true}
          labelId={labelId}
          id={id}
          value={value}
          label={label}
          onChange={handleChange}
          name={name}
          disabled={disabled}
          size="small"
        >
          {items &&
            items.map((item) => {
              return (
                <option className="inputbg_Th" value={item} key={item}>
                  {item}
                </option>
              );
            })}
        </Select>
      </CustomSelectStyle>
    </Box>
  );
}
